import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { i18n } from 'app/i18n';
import { HouseType } from 'app/pages/order/model/house-type';
import { oneMeshUnitImageProps, twoMeshUnitsImageProps } from 'app/resources/images';
import { ImageProps } from 'app/components/image';

import { Description } from './description';
import {
    StyledConnectedMeshUnitImage,
    StyledContainer,
    StyledImage,
    StyledImageContainer,
    StyledImageDescription,
    StyledTitle,
} from './connection-instructions.styled';

export interface ConnectionInstructionsProps {
    houseType: HouseType;
    description: React.ReactNode;
    connectionInstructions: string;
    image: ImageProps;
}

export const ConnectionInstructions: FunctionComponent<ConnectionInstructionsProps> = (props) => {
    const { houseType, description, connectionInstructions, image } = props;

    return (
        <>
            <Description component="p">{description}</Description>
            <StyledContainer>
                <StyledTitle variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
                    {i18n.page.productDetails.connectionInstructions.howItWorks}
                </StyledTitle>
                <StyledImageContainer>
                    <StyledConnectedMeshUnitImage {...image} />
                    <StyledImageDescription variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                        {connectionInstructions}
                    </StyledImageDescription>
                    <StyledImage
                        {...(houseType === HouseType.MEDIUM_HOUSE ? oneMeshUnitImageProps : twoMeshUnitsImageProps)}
                    />
                    <StyledImageDescription variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                        {i18n.page.productDetails.connectionInstructions.multipleMeshUnits[houseType]}
                    </StyledImageDescription>
                </StyledImageContainer>
            </StyledContainer>
        </>
    );
};
